<template>
    <div class="full-height">
        <tob-bar-alert></tob-bar-alert>
        <login v-if="displayAuthFullOverlay"></login>
        <loading v-else-if="displayLoadingFullOverlay"></loading>
        <template v-else>
            <top-bar></top-bar>
            <div class="layout-container" >
                <img
                    v-if="$store.getters.currentEntity"
                    ref="entityImage"
                    class="image-entity"
                    :src="$store.getters.currentEntity.image"
                >
                <div v-if="$store.getters.currentEntity" class="background-gradient" :style="{height: entityImageHeight}">
                </div>
                <router-view></router-view>
            </div>
        </template>
        <div class="build-version">version {{ version }}</div>
    </div>
</template>



<script>
/*global VERSION:true*/
import TopBar from './components/layout/top-bar.vue';
import { Login } from 'gcmcn-common';
import TobBarAlert from 'fundation-app-vuejs/src/components/layouts/dashboard/TopbarAlert.vue';
import Loading from './components/page/Loading';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
    name: 'App',
    components: {
        TopBar,
        TobBarAlert,
        Loading,
        Login,
    },
    data (){
        return {
            entityImageHeight: '0px',
            checkVersionHandler: null,
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'displayAuthFullOverlay',
            'displayLoadingFullOverlay',
        ]),
        version (){
            try{
                return VERSION;
            }catch(e){
                console.error(e);
            }
        },
    },
    created (){
        // obliger d'utiliser le window.location car sinon on refresh la page feed la valeur de $route.name vaut null, on ne sais donc pas sur quel view on est. De plus on ne peux pas ce baser seulement sur this.$store.getters.currentEntity === null car sinon sur la vue des ird où on n'a pas d'ird et la vue de reset de mot de passe on serait rediriger vers la home
        if(window.location.hash.includes('feed') && this.$store.getters.currentEntity === null){
            this.$router.push('/');
        }
    },
    watch: {
        '$store.getters.currentEntity': {
            handler (val){
                this.$nextTick(() => {
                    if(val){
                        this.entityImageHeight = this.$refs.entityImage.clientHeight + 'px';
                    }
                });
            },
            deep: true,
        },
    },
    mounted (){
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
        this.$router.beforeEach((to, from, next) => {
            if(to.name === 'feed' && this.$store.getters.currentEntity === null){
                this.$store.commit('SET_CURRENT_ENTITY', null);
                this.$store.dispatch('setScope', {});
                next({name: 'dashboard'});
            }else if(to.name === 'profile'){
                next({name: 'manage-profile'});
            }else{
                next();
            }
        });
        this.checkVersion();
        this.onResize();
    },
    methods: {
        onResize() {
            this.$store.commit('BROWSER_RESIZED', document.documentElement.clientWidth);
            if(this.$store.getters.currentEntity){
                this.entityImageHeight = this.$refs.entityImage.clientHeight + 'px';
            }
        },
        onSuccess(resp) {
            this.$refs.login.onLoginSuccess(resp);
        },

        checkVersion (){
            axios.get(this.$store.getters.appStatusUrl).then(result => {
                try {
                    if (result.data.version === this.version) {
                        this.$store.dispatch('fundation/is_up_to_date');
                    } else {
                        this.$store.dispatch('fundation/need_update');
                    }
                } catch (e) {
                    console.error('Cannot check version, please ensure webpack build-tool is well configured');
                    this.$store.dispatch('fundation/is_up_to_date');
                }
            }).catch((error) => {
                if(error.response.status == 404){
                    this.$store.commit('fundation/DONT_RETRY_STATUS');
                }
                this.$store.dispatch('fundation/is_up_to_date');
            }).finally(() => {
                this.checkVersionHandler = setTimeout(() => {
                    this.checkVersion();
                }, 10000);
            });
        }
    },
};
</script>

<style lang="scss">
@import './main.scss';
div::-webkit-scrollbar {
    width: 7px;
}
div::-webkit-scrollbar-thumb {
    width: 7px;
    margin-left: 3px;
    border-radius: 15px;
    background-color: rgba(50, 50, 50, 1);
}
.build-version{
    position: fixed;
    bottom: 5px;
    left: 8px;
    font-family: roboto-light;
    font-size: 11px;
}
.layout-container{
    padding: 90px 20px 0 20px;
    height: 100%;
    background-repeat: no-repeat !important;
    background-size: contain !important;
}
.background-gradient{
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(17, 17, 17, 0) -123.9%, #111111 84.64%);
}
.image-entity{
    position: absolute;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
}
.top-bar{
    z-index: 1000 !important;
}
.alert-wrapper.need-update{
    z-index: 1001 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue